// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__AFNBi","textarea":"MessageSender_textarea__wdsPM","button":"MessageSender_button__1DzIB"};